import Chip from '@zenbusiness/zui/Chip';
import Link from '@zenbusiness/zui/Link';
import { superstyled } from '@zenbusiness/zui/styles';

export const PartnerDomainChip = superstyled({
  tag: Chip,
  name: 'SubscriptionDetails',
  slot: 'PartnerDomainChip',
  styles: ({ theme }) => ({
    backgroundColor: theme.palette.background.blue.light,
  }),
});

export const ActivationLink = superstyled({
  tag: Link,
  name: 'SubscriptionDetails',
  slot: 'ActivationLink',
  styles: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.25rem',
    fontSize: '0.875rem',
    fontWeight: 'bold',
  },
});
